<template>
  <v-container text-md-center justify-center>
    <v-layout row wrap>
      <v-flex xs8 mt-5 justify-center>
        <TimelineComponent/>
      </v-flex>
      <v-flex xs4 mt-5 justify-center>
        <TodaysJobComponent/>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
    </v-layout>
  </v-container>
</template>
<script>
import TimelineComponent from '../components/Timeline.vue';
import TodaysJobComponent from '../components/TodaysJob.vue';
export default {
  components: {
    TimelineComponent,
    TodaysJobComponent
  },
  data () {
      return {
      }
  },
}
</script>
